var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.view
    ? _c(
        "div",
        { staticClass: "widthFull mt-5 mb-md-0", attrs: { id: "not_active" } },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-fluid blackGradient pt-md-4 pb-5" },
            [
              _c("div", { staticClass: "row back-color-3 mb-3" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "h1",
                    {
                      staticClass:
                        "uppercase pt-3 pb-2 pt-md-2 pb-md-2  pl-3 mb-3 mt-md-3 white ",
                      class: { h5: _vm.vw < 800 }
                    },
                    [_vm._v("\n          Promozioni terminate\n        ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.view
                ? _c(
                    "div",
                    { staticClass: "row justify-content-center pb-5" },
                    _vm._l(_vm.contests, function(contest, index) {
                      return _c(
                        "router-link",
                        {
                          key: index,
                          staticClass:
                            "\n          col-lg-6 col-md-8 col-10\n          mb-3\n          pl-lg-0\n          pr-lg-0\n          mr-lg-2\n          ml-lg-2\n          box\n        ",
                          class: { "col-lg-7": _vm.vw < 1500 && _vm.vw > 1000 },
                          attrs: {
                            index: index,
                            to: {
                              name: "Contest",
                              params: {
                                id: contest.id,
                                piva: _vm.piva,
                                cod: _vm.cod_client
                              }
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                mouseover: function($event) {
                                  return _vm.mouseOver(index)
                                },
                                click: function($event) {
                                  return _vm.goToContest(index)
                                }
                              }
                            },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "slide-fade" } },
                                [
                                  _vm.active == "ACTIVE" + index
                                    ? _c(
                                        "h4",
                                        {
                                          staticClass: "testo-home center Bold",
                                          style:
                                            "background:rgb(255,255,255);color:" +
                                            contest.config.COLORE_SCURO +
                                            ";background:linear-gradient(328deg, rgba(255,255,255,1) 0%, " +
                                            contest.config.COLORE_CHIARO +
                                            " 15%, " +
                                            contest.config.COLORE_MEDIO_CHIARO +
                                            " 62%, " +
                                            contest.config.COLORE_MEDIO_SCURO +
                                            " 100%, " +
                                            contest.config.COLORE_SCURO +
                                            " 100%);zindex:1000"
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                contest.config.TESTO_HOME
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img-fluid img",
                                attrs: {
                                  src: contest.config.IMMAGINE_HOME_TERMINATA
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-center align-self-center pb-5 pt-5 h1 Medium"
                    },
                    [_vm._m(0)]
                  )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-10" }, [
      _c("h5", { staticClass: "displ uppercase" }, [
        _vm._v("\n          Non sono presenti promozioni terminate\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03244019", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03244019","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/notActive.vue
// module id = null
// module chunks = 